import React, { Component } from "react";
import Auth from "./../../Services/Auth/Auth";
import RequerAceite from "./../../Services/Auth/RequerAceite";
import ClientHelper from "./../../Utils/Helpers/ClientHelper";
import UserHelper from "./../../Utils/Helpers/UserHelper";
import queryString from "query-string";
import { Button, FormControl, FormGroup, Checkbox, ButtonGroup, Modal, Row, Col } from "react-bootstrap";
import { injectIntl, FormattedMessage } from "react-intl";
import Loader from "./../../Elements/Loader/Loader";
import Config from "./../../Config";
import FontAwesome from "react-fontawesome";
import Api from "./../../Services/Api/Api";
import "./Login.css";
import BrazilFlag from "../../Assets/Images/flags/brazil.png";
import USAFlag from "../../Assets/Images/flags/united-states.png";
import SpainFlag from "../../Assets/Images/flags/spain.png";
import LocaleHelper from "./../../Utils/Helpers/LocaleHelper";
import StorageHelper from "./../../Utils/Helpers/StorageHelper";
import NotFound from "../NotFound";
import ForgotPasswordModal from "./ForgotPasswordModal";

class Login extends Component {
    _isMounted = true;

    constructor(props) {
        super(props);
        this.state = {
            hideLogin: false,
            error: false,
            errorMsg: "",
            client: ClientHelper.getClient(),
            login: StorageHelper.get("userLogin") || "",
            pass: "",
            locale: LocaleHelper.getLocale(),
            remember: StorageHelper.get("userLogin") ? true : false,
            hasClient: false,
            logo: undefined,
            response: undefined,
            disabled: false,
            statusMessage: undefined,
            clientStyle: { backgroundColor: "white" },
            clientLogoStyle: { backgroundColor: "white" },
            acceptanceTerms: false,
            preLogin: {},
            showPasswordResetModal: false,
            createNewPassword: false,
            newPassword: {
                password: "",
                confirmPassword: "",
                userId: "",
                sending: false
            },
            errorMsgSamePassword: "",
            tempAccessToken: queryString.parse(this.props.location.search, { ignoreQueryPrefix: true }).token
        };

        this.changeLocale = this.changeLocale.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this._loadClient = this._loadClient.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.acceptTerms = this.acceptTerms.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.showResetPasswordPopup = this.showResetPasswordPopup.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.handleConfirmPassword = this.handleConfirmPassword.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.loginWithAccessToken = this.loginWithAccessToken.bind(this);
    }

    changeLocale(locale) {
        LocaleHelper.setLocale(locale);
        window.location.reload(true);
    }

    handleChange(e) {
        switch (e.target.id) {
            case "Login":
                this.setState({ login: e.target.value });
                break;
            case "Remember":
                this.setState({ remember: !this.state.remember });
                break;
            case "Password":
                this.setState({ pass: e.target.value });
                break;
            default:
        }
    }

    componentDidMount() {
        this._isMounted = true;
        UserHelper.logout();
        this._loadClient();
        if (this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            if (parsed.usr && parsed.pwd) {
                this.setState(
                    {
                        hideLogin: true,
                        login: parsed.usr,
                        pass: parsed.pwd
                    },
                    () => {
                        this.props.history.push(
                            "/" + this.props.match.params.clientName + "/" + this.props.match.path.split("/")[2]
                        );
                    }
                );
            }

            if (parsed.token) {
                this.setState({ tempAccessToken: parsed.token });
                StorageHelper.set("loginWithToken", true, false);

                this.loginWithAccessToken();
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _loadClient() {
        Api.post(
            "api/client/loadClient",
            {
                key: this.props.match.params.clientName
            },
            (response) => {
                if (this._isMounted) {
                    if (response && response.success === true) {
                        ClientHelper.setClient(JSON.stringify(response.data[0]));

                        let statusMessage = this.statusMessage;

                        if (response.data[0].status === "S") {
                            statusMessage = "login.status";
                        }

                        let hideLogin = this.hideLogin;
                        if (this.state.pass) {
                            this.handleSubmit();
                            hideLogin = true;
                        }

                        this.setState({
                            logo: Config.logo.path + response.data[0].logo,
                            hasClient: true,
                            statusMessage,
                            hideLogin,
                            client: {
                                ...ClientHelper.getClient(),
                                info: response.data[0].clientInfo,
                                contract: response.data[0].clientContract
                            },
                            clientStyle: { backgroundColor: UserHelper.getUserColor().backgroundColor },
                            clientLogoStyle: {
                                backgroundColor: UserHelper.getUserColor().backgroundLogo
                            }
                        });
                    } else {
                        this.setState({ hasClient: undefined });
                    }
                }
            }
        );
    }

    redirectToSystem() {
        if (ClientHelper.getClient().setup.type === "free") {
            this.props.history.push("/" + this.props.match.params.clientName + "/isca");
        } else {
            this.props.history.push("/" + this.props.match.params.clientName + "/tracker");
        }
    }

    handleSubmit(event) {
        if (event) event.preventDefault();

        if (this.state.error) this.setState({ error: false });

        const login = this.state.login;
        const pass = this.state.pass;
        const remember = this.state.remember;

        this.setState({ disabled: true });
        Auth.login(this, login, pass, this.props.match.clientName, (success, msg) => {
            if (this._isMounted) {
                this.setState({ disabled: false });
                if (!success) {
                    this.setState({
                        hideLogin: false,
                        error: true,
                        errorMsg: msg
                    });
                    return;
                }
            }
            if (remember) StorageHelper.set("userLogin", login);
            else StorageHelper.remove("userLogin");

            UserHelper.setDevice(0);

            if (this.state.acceptanceTerms) {
                return;
            }

            if (this.state.createNewPassword) {
                return;
            }

            this.redirectToSystem();
        });
    }

    acceptTerms() {
        if (this.state.error) this.setState({ error: false });

        const login = this.state.login;
        const remember = this.state.remember;

        RequerAceite.accept(this, (res) => {
            if (res.success === true) {
                this.setState({ disabled: false });
                if (remember) StorageHelper.set("userLogin", login);
                else StorageHelper.remove("userLogin");

                UserHelper.setDevice(0);

                this.redirectToSystem();
            }
        });
    }

    toggleModal() {
        if (this.state.hideLogin && this.state.acceptanceTerms) {
            this.setState({ hideLogin: false });
        }
        this.setState({ acceptanceTerms: !this.state.acceptanceTerms });
    }

    showResetPasswordPopup() {
        this.setState({ showPasswordResetModal: true });
    }

    updatePassword(event) {
        event.preventDefault();

        const newPassword = this.state.newPassword.password;
        const currentPassword = this.state.pass;
        const userId = this.state.newPassword.userId;
        const key = this.props.match.clientName;

        this.setState({
            newPassword: {
                ...this.state.newPassword,
                sending: true
            }
        });

        Auth.updatePassword(newPassword, currentPassword, userId, key, (success, message) => {
            if (this._isMounted) {
                if (!success) {
                    this.setState({ errorMsg: message });
                    return;
                }

                this.setState({
                    createNewPassword: false,
                    pass: "",
                    newPassword: {
                        ...this.state.newPassword,
                        sending: false
                    }
                });

                UserHelper.setToken(this.state.preLogin.token);
                UserHelper.setUser(this.state.preLogin.user);

                this.redirectToSystem();
            }
        });
    }

    hidePopup() {
        this.setState({ showPasswordResetModal: false });
    }

    handleConfirmPassword(e) {
        var stateValue = "";

        switch (e.target.id) {
            case "novaSenha":
                this.setState({
                    newPassword: {
                        ...this.state.newPassword,
                        password: e.target.value
                    }
                });
                stateValue = this.state.newPassword.confirmPassword;
                break;
            case "confirmarSenha":
                this.setState({
                    newPassword: {
                        ...this.state.newPassword,
                        confirmPassword: e.target.value
                    }
                });
                stateValue = this.state.newPassword.password;
                break;
        }

        if (this.state.newPassword.password !== "" && this.state.newPassword.confirmPassword !== "") {
            if (stateValue !== e.target.value) {
                this.setState({
                    errorMsgSamePassword: "Senhas não coincidem"
                });
            } else {
                this.setState({
                    errorMsgSamePassword: ""
                });
            }
        }
    }

    loginWithAccessToken() {
        Auth.loginWithAccessToken(this.state.tempAccessToken, this.props.match.params.clientName, (success, error) => {
            if (error) {
                let errorMessage = this.props.intl.formatMessage({ id: "login.token_expired" });
                this.setState({
                    error: true,
                    errorMsg: errorMessage
                });
            }
            if (success) {
                this.redirectToSystem();
            }
        });
    }

    render() {
        if (this.state.hasClient === false || this.state.hideLogin) {
            return (
                <React.Fragment>
                    <Loader positionFromTop="50%" position="fixed" />

                    <Modal name="acceptanceTerms" show={this.state.acceptanceTerms} onHide={this.toggleModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <div>
                                    <FontAwesome name="file-signature" /> <FormattedMessage id="login.terms" />
                                </div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col md={10}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.intl.formatMessage(
                                                {
                                                    id: "login.clientTerms"
                                                },
                                                {
                                                    clientName: this.props.match.params.clientName,
                                                    extension: "pdf"
                                                }
                                            )
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button bsStyle="danger" name="acceptanceTerms" onClick={this.toggleModal}>
                                <FormattedMessage id="close" />
                            </Button>
                            <Button bsStyle="success" onClick={this.acceptTerms}>
                                <FormattedMessage id="login.acceptTerms" />
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </React.Fragment>
            );
        }

        if (this.state.hasClient === undefined) {
            return <NotFound />;
        }

        if (
            this.state.hasClient === true &&
            !this.state.hideLogin &&
            (!this.state.tempAccessToken || this.state.error)
        ) {
            return (
                <React.Fragment>
                    <Modal name="acceptanceTerms" show={this.state.acceptanceTerms} onHide={this.toggleModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <div>
                                    <FontAwesome name="file-signature" /> <FormattedMessage id="login.terms" />
                                </div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col md={10}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.intl.formatMessage(
                                                {
                                                    id: "login.clientTerms"
                                                },
                                                {
                                                    clientName: this.props.match.params.clientName,
                                                    extension: "pdf"
                                                }
                                            )
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button bsStyle="danger" name="acceptanceTerms" onClick={this.toggleModal}>
                                <FormattedMessage id="close" />
                            </Button>
                            <Button bsStyle="success" onClick={this.acceptTerms}>
                                <FormattedMessage id="login.acceptTerms" />
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <ForgotPasswordModal
                        visible={this.state.showPasswordResetModal}
                        clientKey={this.props.match.clientName}
                        hidePopup={this.hidePopup}
                    />

                    <div className="Login">
                        {!this.state.createNewPassword && (
                            <div className="row">
                                <div className="card card-container">
                                    <div className="card-logo" style={this.state.clientLogoStyle}>
                                        <img
                                            id="profile-img"
                                            alt="logo"
                                            className="profile-img-card"
                                            src={this.state.logo}
                                        />
                                    </div>
                                    <div className="card-form">
                                        <form className="form-signin" onSubmit={this.handleSubmit}>
                                            <span id="reauth-login" className="reauth-login" />
                                            {this.state.statusMessage && (
                                                <h3>
                                                    {" "}
                                                    <FormattedMessage id={this.state.statusMessage} />{" "}
                                                </h3>
                                            )}
                                            <FormGroup controlId="Login">
                                                <FormControl
                                                    type="text"
                                                    value={this.state.login}
                                                    autoFocus={!this.state.login}
                                                    placeholder={this.props.intl.formatMessage({
                                                        id: "login"
                                                    })}
                                                    onChange={this.handleChange}
                                                />
                                                <FormControl.Feedback />
                                            </FormGroup>

                                            <FormGroup controlId="Password">
                                                <FormControl
                                                    type="password"
                                                    autoFocus={!!this.state.login}
                                                    placeholder={this.props.intl.formatMessage({
                                                        id: "password"
                                                    })}
                                                    onChange={this.handleChange}
                                                />
                                                <FormControl.Feedback />
                                            </FormGroup>

                                            <Checkbox
                                                checked={this.state.remember}
                                                id="Remember"
                                                value={this.state.remember}
                                                onChange={this.handleChange}
                                            >
                                                <FormattedMessage id="login.remember" />
                                            </Checkbox>

                                            <Button
                                                type="submit"
                                                style={this.state.clientStyle}
                                                bsStyle="primary"
                                                className="btn-block btn-signin"
                                                disabled={!this.state.login || !this.state.pass || this.state.disabled}
                                            >
                                                {this.state.disabled && <FontAwesome name="spinner" spin />}{" "}
                                                <FormattedMessage id="send" />
                                            </Button>

                                            {this.state.errorMsg && (
                                                <div className="alert alert-danger">{this.state.errorMsg}</div>
                                            )}
                                        </form>

                                        <Row>
                                            <Col style={{ textAlign: "right", padding: "0 15px", cursor: "pointer" }}>
                                                <a onClick={this.showResetPasswordPopup}>
                                                    <FormattedMessage id="password.forgot" />
                                                </a>
                                            </Col>
                                        </Row>

                                        <ButtonGroup>
                                            <Button
                                                type="button"
                                                bsStyle="default"
                                                className={this.state.locale === "pt" ? "active" : ""}
                                                onClick={() => this.changeLocale("pt")}
                                            >
                                                <img src={BrazilFlag} alt="pt" />
                                            </Button>
                                            <Button
                                                type="button"
                                                bsStyle="default"
                                                className={this.state.locale === "en" ? "active" : ""}
                                                onClick={() => this.changeLocale("en")}
                                            >
                                                <img src={USAFlag} alt="en" />
                                            </Button>
                                            <Button
                                                type="button"
                                                bsStyle="default"
                                                className={this.state.locale === "es" ? "active" : ""}
                                                onClick={() => this.changeLocale("es")}
                                            >
                                                <img src={SpainFlag} alt="es" />
                                            </Button>
                                        </ButtonGroup>
                                        <div className="paddingTop">
                                            <FormattedMessage id="login.browsers" />:<br />
                                            <i className="fab fa-chrome" /> <i className="fab fa-firefox" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {this.state.createNewPassword && (
                            <div className="row">
                                <div className="card card-container">
                                    <div className="card-logo" style={this.state.clientLogoStyle}>
                                        <img
                                            id="profile-img"
                                            alt="logo"
                                            className="profile-img-card"
                                            src={this.state.logo}
                                        />
                                    </div>
                                    <div className="card-form">
                                        <form className="form-signin" onSubmit={this.updatePassword}>
                                            <span id="reauth-login" className="reauth-login" />

                                            <h3 style={{ marginTop: "-8px", textAlign: "center" }}>
                                                {" "}
                                                <FormattedMessage id="createNewPassword" />{" "}
                                            </h3>

                                            <FormGroup controlId="novaSenha">
                                                <FormControl
                                                    type="password"
                                                    value={this.state.newPassword.password}
                                                    autoFocus={true}
                                                    placeholder={this.props.intl.formatMessage({
                                                        id: "newPassword"
                                                    })}
                                                    onChange={this.handleConfirmPassword}
                                                />
                                                <FormControl.Feedback />
                                            </FormGroup>

                                            <FormGroup controlId="confirmarSenha">
                                                <FormControl
                                                    type="password"
                                                    value={this.state.newPassword.confirmPassword}
                                                    placeholder={this.props.intl.formatMessage({
                                                        id: "confirmPassword"
                                                    })}
                                                    onChange={this.handleConfirmPassword}
                                                />
                                                <FormControl.Feedback />
                                            </FormGroup>

                                            {this.state.errorMsgSamePassword && (
                                                <div className="alert alert-danger">
                                                    {this.state.errorMsgSamePassword}
                                                </div>
                                            )}

                                            <Button
                                                type="submit"
                                                style={this.state.clientStyle}
                                                bsStyle="primary"
                                                className="btn-block btn-signin"
                                                disabled={
                                                    this.state.newPassword.password === "" ||
                                                    this.state.newPassword.confirmPassword === "" ||
                                                    this.state.newPassword.sending === true
                                                }
                                            >
                                                {this.state.newPassword.sending && <FontAwesome name="spinner" spin />}{" "}
                                                <FormattedMessage id="send" />
                                            </Button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
}

export default injectIntl(Login, {
    withRef: true
});
